const INITIAL_STATE = {
  language: 'en',
  all: ['de', 'en', 'es', 'fr', 'it'],
  current: null,
}

export default {
  namespaced: true,
  state: {
    ...INITIAL_STATE
  },
  getters: {
    find: (state) => (lang) => state.find(el => el === lang),
    getLocalizationByKey: (state) => (key) => {
      const localized = state.current ? state.current[key] : null
      
      if (
        !localized && state.current
        && Object.keys(state.current).length > 0
      ) {
        if (!window.MISSING_I18N) {
          window.MISSING_I18N = {}
        }
        
        window.MISSING_I18N[key] = key
        console.warn(`[missing translation] ${key} see window.MISSING_I18N`)
      }
      
      return localized || key
    },
  },
  mutations: {
    setLanguage: (state, lang) => {
      state.language = lang
    },
    setCurrent: (state, { item }) => {
      state.current = item
    },
    add: (state, { item, prepend = false }) => {
      if (prepend) {
        state.all.unshift(item)
      } else {
        state.all.push(item)
      }
    },
    remove: (state, { id }) => {
      let idx = state.all.findIndex(el => el.id === id)
      state.all.splice(idx, 1)
    },
    
  },
  actions: {
    get: ({ dispatch, rootGetters, commit }, { language }) => {
      const headers = {
        'Content-Type': 'application/json',
      }
      
      Object.assign(headers, rootGetters['Api/getAuthHeader'])
      
      return dispatch('Api/apiRequest', {
        actionPath: ['/api/localizations/get/', language, '.json'].join(''),
        method: 'get',
        headers: headers,
      }, { root: true })
        .then(result => {
          commit('setLanguage', language)
          commit('setCurrent', { item: result })
          
          return Promise.resolve(result)
        })
    },
  },
}
